var dropdownItemIndicator = 'fx_2d2fb1e5_1unj1vb0';

export { dropdownItemIndicator };
//# sourceMappingURL=itemIndicator.vanilla.mjs.map
